import { Injectable, inject } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectRoleData {
  private _api = inject(FsApi);


  public get(id: number, query = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.get(`projectroles/${id}`, query, { key: 'projectRole', ...config });
  }

  public gets(data = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.request('GET', 'projectroles', data, { key: 'projectRoles' , ...config });
  }

  public put(data, config: RequestConfig = {}): Observable<any> {
    return this._api.put(`projectroles/${data.id}`, data, { key: 'projectRoles' , ...config });
  }

  public post(data, config: RequestConfig = {}): Observable<any> {
    return this._api.post('projectroles', data, { key: 'projectRoles' , ...config });
  }

  public delete(data, config: RequestConfig = {}): Observable<any> {
    return this._api.delete(`projectroles/${data.id}`, data, { key: 'projectRoles' , ...config });
  }

  public save(data): Observable<any> {
    if (data.id) {
      return this.put(data);
    }

    return this.post(data);
  }

  public order(data): Observable<any> {
    return this._api.put('projectroles/order', data, { key: null });
  }
}
